import * as z from "zod";

export const getTotesByFulfillmentGroupId = {
  name: "getTotesByFulfillmentGroupId" as const,
  input: z.object({ fulfillmentGroupId: z.string() }),
  output: z.object({
    totes: z.array(
      z.object({
        toteId: z.string(),
        toteBarcode: z.string(),
        name: z.string().nullish(),
      }),
    ),
  }),
};
